var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62222 7.24174C4.42665 7.24177 5.20808 6.97333 5.84272 6.47895L8.23701 8.8736C8.41587 9.04637 8.70088 9.04141 8.87362 8.86252C9.04213 8.68802 9.04213 8.41138 8.87362 8.23689L6.47933 5.84224C7.70592 4.26305 7.42029 1.98836 5.84133 0.761584C4.26238 -0.465194 1.98806 -0.179519 0.761469 1.39967C-0.465123 2.97887 -0.179492 5.25355 1.39946 6.48033C2.03514 6.97423 2.81727 7.24215 3.62222 7.24174ZM1.69843 1.6973C2.76092 0.634633 4.48356 0.634614 5.54607 1.69727C6.60858 2.75992 6.6086 4.48282 5.54611 5.54549C4.48362 6.60816 2.76098 6.60818 1.69847 5.54553L1.69843 5.54549C0.635941 4.49058 0.629681 2.77396 1.68443 1.71131L1.69843 1.6973Z",
    fill: "#76808F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.3db10629690c8a657686980665b656aa.svg";
export { ForwardRef as ReactComponent };